import classnames from 'classnames';
import React from 'react';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { ShortUnderlineInput } from 'swag-client-common/components/inputs/pink-underline-input';
import { ColorLabel } from 'swag-client-common/components/ui/color-label';
import OutOfStockMessage from 'swag-client-common/components/ui/out-of-stock-message';
import { getSupplierInStockQuantityBySize } from 'swag-client-common/utils/product.utils';
import { HiddenLabel } from 'swag-client-common/components/hidden-label';
import classes from './quantity-per-size.scss';
export function QuantityPerSize(props) {
  const {
    sizes = [],
    quantities,
    bundleQuantities = {},
    sharedQuantities,
    inStockQuantities,
    onChange,
    onFocus,
    onBlur,
    showColor,
    colorValue,
    colorName,
    outOfStockSizes,
    disabled = false,
    skipOutOfStock = false,
    viewMode,
    sizeContainerClassName = '',
    inputClassName = '',
    sizeItemClassName = '',
    sizeItemInputWrapperClassName = '',
    sizeItemInputClassName = '',
    sizeItemLabelClassName = '',
    quantityPerSizeWrapperClassName = '',
    colorLabelClassName = '',
    stockLevelsByVariantSku,
    variant,
    productIsAlwaysInStock,
    colorBehavior = [],
    withLabelTooltip
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    "data-color-block": colorName,
    className: quantityPerSizeWrapperClassName
  }, showColor && /*#__PURE__*/React.createElement(ColorLabel, {
    colorName: colorName,
    colorValue: colorValue,
    className: classnames(classes.buttonContainerLeft, classes.colorButtonWrapper, colorLabelClassName)
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.sizesContainer, sizeContainerClassName)
  }, quantities && sizes.map((sizeName, sizeIndex) => {
    var _variant$sizeSkus, _colorBehavior$sizeIn;
    const inStockQuantity = inStockQuantities ? inStockQuantities[sizeIndex] : Infinity;
    const supplierInStockQuantity = getSupplierInStockQuantityBySize({
      isAlwaysInStock: productIsAlwaysInStock || (variant === null || variant === void 0 ? void 0 : variant.isAlwaysInStockVariant),
      variantSizeSkus: (_variant$sizeSkus = variant === null || variant === void 0 ? void 0 : variant.sizeSkus) !== null && _variant$sizeSkus !== void 0 ? _variant$sizeSkus : {},
      currentSizeName: sizeName,
      stockLevelsByVariantSku
    });
    const quantity = quantities[sizeIndex];
    const {
      bundleQuantity,
      isInvalid
    } = bundleQuantities[sizeIndex] || {
      bundleQuantity: 0,
      isInvalid: false
    };
    const quantityToValidate = (sharedQuantities === null || sharedQuantities === void 0 ? void 0 : sharedQuantities[sizeIndex]) || quantity;
    const inStockValidationBundleQuantity = isInvalid ? inStockQuantity : null;
    const isOutOfStock = outOfStockSizes === null || outOfStockSizes === void 0 ? void 0 : outOfStockSizes.has(sizeIndex);
    const isDisabled = isOutOfStock && !skipOutOfStock && !quantity || supplierInStockQuantity === 0 && !quantity;
    const behavior = ((_colorBehavior$sizeIn = colorBehavior[sizeIndex]) === null || _colorBehavior$sizeIn === void 0 ? void 0 : _colorBehavior$sizeIn.color) || '';
    const inputId = `quantityForSize-${sizeName}-${variant === null || variant === void 0 ? void 0 : variant.name}`;
    return /*#__PURE__*/React.createElement("div", {
      key: sizeIndex,
      "data-size-block": sizeName,
      className: classnames(classes.sizeItem, sizeItemClassName, {
        [classes.disabled]: disabled
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.input, sizeItemInputWrapperClassName)
    }, /*#__PURE__*/React.createElement(HiddenLabel, {
      htmlFor: inputId,
      label: `Quantity for ${sizeName} size:`
    }), /*#__PURE__*/React.createElement(ShortUnderlineInput, {
      id: inputId,
      dataColorName: colorName,
      dataInput: sizeName,
      dataPerSizeInput: sizeName,
      onFocus: onFocus,
      onBlur: () => onBlur ? onBlur(sizeIndex) : null,
      className: classnames(sizeItemInputClassName, inputClassName, {
        [classes.disabled]: isDisabled,
        [classes[behavior]]: !!behavior
      }),
      disabled: isDisabled,
      viewMode: viewMode,
      value: quantity || 0,
      onChange: e => onChange({
        value: parseInt(e.target.value) || 0,
        sizeIndex,
        sizeName
      })
    })), withLabelTooltip ? /*#__PURE__*/React.createElement(Tooltip, {
      title: sizeName,
      mode: "dark",
      placement: "bottom"
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.label, sizeItemLabelClassName)
    }, sizeName)) : /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.label, sizeItemLabelClassName)
    }, sizeName), /*#__PURE__*/React.createElement(OutOfStockMessage, {
      twoLines: true,
      showCompletelyOutOfStockMessage: true,
      inStockQuantity: supplierInStockQuantity === 0 || supplierInStockQuantity < quantityToValidate ? supplierInStockQuantity : null
    }), !bundleQuantity || inStockValidationBundleQuantity === null ? /*#__PURE__*/React.createElement(OutOfStockMessage, {
      twoLines: true,
      inStockQuantity: inStockQuantity < quantityToValidate + bundleQuantity ? inStockQuantity : null
    }) : /*#__PURE__*/React.createElement(OutOfStockMessage, {
      twoLines: true,
      inStockQuantity: inStockValidationBundleQuantity,
      showCurrentStockMessage: true
    }));
  })));
}